import { useQuery } from "@tanstack/react-query";
import orderCore from "../../core/order.core";
import { Cart } from "../../types/cart";
import { useRouter } from "next/router";
import { toast } from "react-toastify";
import { useTranslation } from "../../core/translation.core";
import Cookies from "js-cookie";
import Accordion from "../common/accordion.comp";

export default function CombineOrder({ cart, userId, sessionId }: { cart: Cart; userId: string; sessionId: string }) {
  const router = useRouter();
  const { t, msg } = useTranslation();
  const { data } = useQuery({
    queryKey: ["Combine-Order", cart, userId],
    queryFn: () => orderCore.getCombineOrder({ sessionId: sessionId, userId }),
    enabled: !!userId && !!sessionId && cart.items.length > 0,
    retry: 3,
  });

  async function handleCombineOrder(orderId: string) {
    await orderCore
      .combineOrder({
        orderId,
        cartId: cart.id,
        sessionId,
        userId,
      })
      .then((msg: any) => {
        toast.success("Success");
        Cookies.remove("sessionId");
        router.push("/orders");
      })
      .catch((err: any) => {
        toast.error(t(msg.errors.contactAdmin));
      });
  }

  if (!data || data.orders?.length < 1) return null;

  return (
    <div className="w-full">
      <Accordion title={t(msg.order.combineOrderMessage)}>
        {data.orders.map((order) => (
          <div className="flex justify-between mb-1" key={order.id}>
            <p>#{order.orderNumber}</p>
            <button
              onClick={() => handleCombineOrder(order.id)}
              className="flex-center bg-black/60 hover:bg-black/80 text-white py-1 px-2 w-fit rounded-lg disabled:bg-gray-500 disabled:cursor-not-allowed"
            >
              {t(msg.order.combineOrder)}
            </button>
          </div>
        ))}
      </Accordion>
    </div>
  );
}
